/**
 * Aug-2026 (User-Wunsch) — wiederverwendbarer „Auf Etikettenbogen drucken"-Block
 * für alle Theken-QR-Karten (Direktverkauf, Artikel-Check, Barcode-Erfassung,
 * Fahrzeugannahme). Format-Auswahl (Avery-Presets) oder eigene Maße in mm.
 */
import { useState } from "react";
import { Printer, Tag } from "lucide-react";
import { openQrLabelPrint, LABEL_FORMATS } from "../lib/qrPrint";

export const QrLabelSheetButton = ({ scanUrl, label = "", testidPrefix = "qr-label" }) => {
    const [open, setOpen] = useState(false);
    const [fmt, setFmt] = useState(LABEL_FORMATS[0].id);
    const [customW, setCustomW] = useState("");
    const [customH, setCustomH] = useState("");

    const handlePrint = () => {
        const preset = LABEL_FORMATS.find((f) => f.id === fmt);
        const wMm = fmt === "custom" ? Number(String(customW).replace(",", ".")) : preset?.w;
        const hMm = fmt === "custom" ? Number(String(customH).replace(",", ".")) : preset?.h;
        openQrLabelPrint({ scanUrl, label, widthMm: wMm, heightMm: hMm });
    };

    if (!scanUrl) return null;
    return (
        <>
            <button type="button" onClick={() => setOpen((v) => !v)}
                className="mt-1.5 w-full inline-flex items-center justify-center gap-2 border border-gray-300 text-gray-800 rounded-sm py-2 text-xs font-bold uppercase tracking-wider hover:bg-gray-50"
                data-testid={`${testidPrefix}-toggle`}>
                <Tag className="w-4 h-4" /> Auf Etikettenbogen drucken
            </button>
            {open && (
                <div className="mt-2 border border-gray-200 rounded-sm p-2.5 bg-gray-50/70 space-y-2 text-left" data-testid={`${testidPrefix}-form`}>
                    <label className="block">
                        <span className="text-[10px] font-bold uppercase tracking-wider text-gray-500">Etikettengröße (A4-Bogen)</span>
                        <select value={fmt} onChange={(e) => setFmt(e.target.value)}
                            className="w-full rounded-sm h-8 mt-0.5 bg-white border border-input px-2 text-xs"
                            data-testid={`${testidPrefix}-format`}>
                            {LABEL_FORMATS.map((f) => <option key={f.id} value={f.id}>{f.name}</option>)}
                            <option value="custom">Eigene Maße eingeben …</option>
                        </select>
                    </label>
                    {fmt === "custom" && (
                        <div className="flex items-center gap-2">
                            <input type="number" min="15" max="210" step="0.1" value={customW}
                                onChange={(e) => setCustomW(e.target.value)} placeholder="Breite mm"
                                className="w-full rounded-sm h-8 bg-white border border-input px-2 text-xs"
                                data-testid={`${testidPrefix}-w`} />
                            <span className="text-xs text-gray-400">×</span>
                            <input type="number" min="15" max="297" step="0.1" value={customH}
                                onChange={(e) => setCustomH(e.target.value)} placeholder="Höhe mm"
                                className="w-full rounded-sm h-8 bg-white border border-input px-2 text-xs"
                                data-testid={`${testidPrefix}-h`} />
                        </div>
                    )}
                    <button type="button" onClick={handlePrint}
                        disabled={fmt === "custom" && (!customW || !customH)}
                        className="w-full inline-flex items-center justify-center gap-2 bg-[#FFCC00] hover:bg-[#E6B800] text-[#111827] rounded-sm py-2 text-xs font-black uppercase tracking-wider disabled:opacity-50"
                        data-testid={`${testidPrefix}-print`}>
                        <Printer className="w-4 h-4" /> Etikettenbogen drucken
                    </button>
                    <p className="text-[10px] text-gray-400">Der A4-Bogen wird automatisch mit dem QR-Code gefüllt (Anzahl je nach Etikettengröße) und passgenau zentriert.</p>
                </div>
            )}
        </>
    );
};
